import React from 'react';
import { Tabs, Badge, styled, Tab, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { lighten } from '@mui/material/styles';

const StyledTab = styled(Tab)(({theme}) => ({
    textTransform: 'initial',
    alignItems: 'flex-start',
    color: theme.palette.tertiary.light,
    opacity: 0.7,
    transition: 'background-color .5s ease',
    '& > span': {
        display: 'flex',
        '& > div': {
            paddingLeft: '12px',
        },
    },
    '&.Mui-disabled' : {
        pointerEvents: 'unset',
    },
    '&.Mui-selected': {
        opacity: 1,
        color: theme.palette.tertiary.light,
    },
    '&:hover': {
        backgroundColor: lighten(theme.palette.tertiary.light, 0.75),
    },
    padding: 0,
    lineHeight: '48px',
    '& .MuiBadge-root': {
        paddingLeft: '12px',
        paddingRight: '12px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiBadge-badge': {
            marginRight: '12px',
        },
    },
}));

function RpFiltersTabsList(props) {

    const tooltipMessage = (tab) => {
        if (!tab.disabled) return '';

        return tab.advancedFilter ? props.featureLocked : 'Coming soon';
    };

    return (
        <Tabs
            orientation="vertical"
            value={props.tabIndex}
            onChange={props.onTabChange}
            sx={{ borderRight: 1, borderColor: 'divider', minWidth: 200 }}
            slotProps={{
                indicator: {
                    sx: {
                        left: 0,
                        right: 'auto',
                        width: 2,
                    }
                }
            }}
        >
            {props.tabs.map((tab) => (
                <StyledTab
                    key={tab.value}
                    disabled={tab.disabled}
                    label={
                        tab.contentCount > 0
                            ? (
                                <Badge
                                    badgeContent={tab.contentCount}
                                    color="primary"
                                    sx={{
                                        width: '100%',
                                        '& .MuiBadge-colorPrimary': {
                                            background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #2196F3',
                                            fontSize: '12px',
                                            letterSpacing: '0.14px',
                                            right: 0,
                                            top: 'unset',
                                            transform: 'none',
                                        },
                                    }}
                                >
                                    {tab.label}
                                </Badge>
                            )
                            : <Tooltip
                                title={tooltipMessage(tab) || ''}
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            lineHeight: 1.5,
                                            fontSize: '11px',
                                            padding: 1.5,
                                        }
                                    },
                                }}
                                arrow
                                placement="right"
                            >
                                <span>
                                    <div>{tab.label}</div>
                                </span>
                            </Tooltip>
                    }
                    value={tab.value}
                />
            ))}
        </Tabs>
    );
}


RpFiltersTabsList.propTypes = {
    tabs: PropTypes.array.isRequired,
    tabIndex: PropTypes.any,
    onTabChange: PropTypes.func,
};

export default React.memo(RpFiltersTabsList);